import { useState } from "react"
import { toast } from "sonner"
import { useAsync } from "@mylaunch/components/hooks"
import { Result } from "@praha/byethrow"
import { useQueryClient } from "@tanstack/react-query"
import { ImSpinner2 } from "react-icons/im"
import { Button } from "~/components/ui/button"
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "~/components/ui/alert-dialog"
import { unsubscribe } from "../server/plans.functions"
import { plansQueryKey } from "../hooks/use-plans"

export function UnsubscribeButton() {
  const [open, setOpen] = useState(false)
  const queryClient = useQueryClient()
  const { loading, run } = useAsync(() =>
    unsubscribe({
      data: undefined,
    }))

  const handleConfirm = async () => {
    const result = await run()
    if (Result.isFailure(result)) {
      toast.error("Не удалось отменить подписку")
      return
    }
    await queryClient.invalidateQueries({ queryKey: plansQueryKey })
    setOpen(false)
  }

  return (
    <>
      <div className="flex items-center gap-s">
        <Button variant="ghost" className="text-muted-foreground self-start -ml-m" onClick={() => setOpen(true)}>
          Отменить подписку
        </Button>
        {loading && <ImSpinner2 className="animate-spin size-icon-s text-muted-foreground" />}
      </div>
      <AlertDialog open={open} onOpenChange={setOpen}>
        <AlertDialogContent onDismiss={() => setOpen(false)}>
          <AlertDialogHeader>
            <AlertDialogTitle>Отменить подписку?</AlertDialogTitle>
            <AlertDialogDescription>Доступ сохранится до конца оплаченного периода.</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>Нет</AlertDialogCancel>
            <AlertDialogAction variant="destructive" onClick={handleConfirm} disabled={loading}>
              Отменить
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  )
}
